module.exports = __webpack_public_path__ + "static/media/p2top.dd0234c1.png";